import { ArrowLeftOnRectangleIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";

import {
  exitImpersonation,
  getImpersonatedUser,
  isImpersonating,
} from "../../user/utils/user";

import { db } from "../../data/utils/data";
import Popup from "./Popup";

function ImpersonationBanner({ t, showAlert }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState({
    title: "",
    message: "",
    button: "",
    onSubmit: null,
    type: "warning",
  });

  if (!isImpersonating()) {
    return null;
  }

  const impersonatedUser = getImpersonatedUser();
  const displayValue =
    impersonatedUser?.email || t("user.unknownUser", "Unknown User");

  const handleExitImpersonation = async () => {
    let message = t(
      "user.exitImpersonationConfirm",
      "Are you sure you want to stop viewing as this user and return to your admin account?",
    );
    let type = "warning";

    try {
      const dataCount = await db.data.count();
      const imageCount = await db.images.count();
      if (dataCount > 0 || imageCount > 0) {
        message = t(
          "user.exitImpersonationConfirmWithData",
          "Warning: You have unsubmitted data. Exiting impersonation will clear all local data for this user. Are you sure you want to proceed?",
        );
        type = "error";
      }
    } catch (error) {
      console.error("Error checking data before exit:", error);
    }

    setPopupData({
      title: t("user.exitImpersonation", "Exit Impersonation"),
      message: message,
      button: t("user.exitImpersonation", "Exit Impersonation"),
      onSubmit: exitImpersonation,
      type: type,
    });
    setIsPopupOpen(true);
  };

  return (
    <>
      <Popup
        open={isPopupOpen}
        setOpen={setIsPopupOpen}
        title={popupData.title}
        message={popupData.message}
        button={popupData.button}
        onSubmit={popupData.onSubmit}
        type={popupData.type}
      />
      {/* Spacer to push down the main content when banner is visible */}
      <div className="h-10" />
      <div className="fixed top-0 left-0 right-0 z-[60] bg-orange-600 text-white shadow-lg">
        <div className="flex items-center justify-between px-4 py-2">
          <div className="flex items-center gap-2">
            <span className="font-semibold">
              {t("user.viewingAs", "Viewing as:")}{" "}
            </span>
            <span className="font-bold text-orange-100">{displayValue}</span>
            <span className="text-orange-200 text-sm">
              {t("user.impersonationMode", "(Impersonation Mode)")}
            </span>
          </div>
          <button
            onClick={handleExitImpersonation}
            className="flex items-center gap-2 px-4 py-1.5 bg-white text-orange-600 rounded-md font-medium hover:bg-orange-50 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-orange-600"
          >
            <ArrowLeftOnRectangleIcon className="h-5 w-5" />
            {t("user.exitImpersonation", "Exit Impersonation")}
          </button>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(ImpersonationBanner);
